import {Injectable} from "@angular/core";
import {støtterPdfjs} from "../støttefunksjoner/pdfjs";

/** Tjeneste som eksponerer informasjon om ulike kapasiteter klienten har eller ikke-har */
@Injectable({providedIn: 'root'})
export class KlientKapasiteter {

    constructor() {
    }

    /** Sann dersom klienten støtter PDFjs */
    støtterPdfjs(): boolean {
        return støtterPdfjs();
    }

}
